import { render, staticRenderFns } from "./RetornoArsenalBloco.vue?vue&type=template&id=06e4d412&"
import script from "./RetornoArsenalBloco.vue?vue&type=script&lang=js&"
export * from "./RetornoArsenalBloco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports